import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-thirty-seven',
  templateUrl: './home-thirty-seven.component.html',
  styleUrls: ['./home-thirty-seven.component.scss']
})
export class HomeThirtySevenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
